import React from 'react';
import PageHeader from 'app/components/PageHeader';
import { Title } from 'app/components/Typography/Title';
const Header = ({ onBack }: any) => {
  return (
    <PageHeader onBack={onBack} title={'Prev Step'}>
      <Title level={5}>Book Inspection</Title>
      <div></div>
    </PageHeader>
  );
};

export default Header;
